const fromStoreByIdQueryToStore = (data)=>{
    if (!data) {
        return null;
    }
    const { globalStoreId , town , streetName , name , postalCode , additionalStreetInfo , streetNumber , code , country , province , lat , lon , phone , email , slug ,  } = data;
    return {
        globalStoreId,
        town,
        streetName,
        name,
        code,
        country,
        phone,
        postalCode: postalCode ? postalCode : undefined,
        additionalStreetInfo: additionalStreetInfo ? additionalStreetInfo : undefined,
        streetNumber: streetNumber ? streetNumber : undefined,
        province: province !== null && province !== void 0 ? province : undefined,
        lat: lat !== null && lat !== void 0 ? lat : undefined,
        lon: lon !== null && lon !== void 0 ? lon : undefined,
        email: email !== null && email !== void 0 ? email : undefined,
        slug: slug !== null && slug !== void 0 ? slug : undefined
    };
};

export { fromStoreByIdQueryToStore };
//# sourceMappingURL=fromStoreByIdQueryToStore.js.map
